import React from 'react';
import LoginForm from '../components/LoginForm';
import AuthService from '../services/AuthService';
import { useAuth } from '../context/AuthContext';
import { useForm } from 'react-hook-form';
import { showSuccessToast, showErrorToast } from '../utils/AlertUtils';
import { useLoading } from '../context/LoadingContext';

const Login = () => {
  const { setIsLoading } = useLoading();
  
  const { login } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm(); // Get register and handleSubmit

  const onSubmit = async (data) => { // data now contains the form values
    setIsLoading(true);
    try {
      const { identifier, password } = data; // Access form values directly

      const authData = await AuthService.login(identifier, password);
      if(authData) {
        showSuccessToast(authData.message);
        login(authData?.data?.token, authData?.data?.userDetail);
      }
    } catch (err) {
      showErrorToast(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoginForm onSubmit={handleSubmit(onSubmit)} register={register} errors={errors} />
  );
};

export default Login;